export default __webpack_public_path__ + "static/media/teacher-account.2762ffce.svg";